import React from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { GlobalStyle } from './styles/global'
import { theme } from './styles/theme'
import Header from './components/Header'
import Hero from './components/PageSection'
import Footer from './components/Footer'
import Contact from './pages/Contact'
import Questions from './pages/Questions'
import HomePage from './pages/HomePage'
import Information from './pages/Information'
import styled from 'styled-components'

const MainContainer = styled.div`
  padding-top: 12rem;
  
  @media (max-width: 890px) {
    padding-bottom: 20rem; // 移动端底部增加间距
  }
`
const App = () => (
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <Router>
      <Header />
      <MainContainer>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/question" element={<Questions />} />
          <Route path="/information" element={<Information />} />
          <Route path="/information/detail" element={<Information />} />
        </Routes>
        <Footer />
      </MainContainer>
    </Router>
  </ThemeProvider>
)

export default App